<div class="row">
  <section class="col-xs-12 col-md-6" *ngFor="let i of menuItems">
    <div class="menuitem-wrap">
      <div class="menuitem">
        <header>
          <h3>{{i.name ? i.name : i.menuItem.name }}</h3>
        </header>
        <p *ngIf="i.description || i.menuItem.description">{{i.description ? i.description : i.menuItem.description }}</p>

        <ul class="allergies" *ngIf="i.menuItem.dietaryPreferences" aria-label="allergies">
          <li *ngFor="let a of i.menuItem.dietaryPreferences">
            <span matTooltip="{{a.name}}{{a.description ? ':' + a.description : ''}}">
              <img src="{{a.image.jpg}}" alt="{{a.name}}" title="{{a.name}}">
            </span>  
          </li>
        </ul>
      </div>
      <span class="price" [class.extra]="costExtra" *ngIf="i.price && !isArray(i.price)">{{i.price | cleanPrice}}</span>

    </div>
  </section>
</div>
